import { Outlet, useLocation } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'
import { StickyBookBar } from '@/components/layout/StickyBookBar'
import { LocalBusinessJsonLd } from '@/components/seo/LocalBusinessJsonLd'
import { cn } from '@/lib/utils'

export function SiteLayout() {
  const { pathname } = useLocation()
  const isBookingRoute = pathname === '/booking' || pathname.startsWith('/booking/')

  return (
    <>
      <LocalBusinessJsonLd />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main
        id="main-content"
        className={cn(
          'min-h-[60vh]',
          isBookingRoute
            ? 'pb-0'
            : 'pb-[var(--sticky-book-bar-height)] min-[900px]:pb-5',
        )}
      >
        <Outlet />
      </main>
      {!isBookingRoute ? <Footer /> : null}
      {!isBookingRoute ? <StickyBookBar /> : null}
    </>
  )
}
